import React, { useRef, useEffect } from 'react'
import { Doughnut } from 'react-chartjs-2'
import Chart from 'chart.js/auto'

const centerTextPlugin = {
  id: 'centerTextPlugin',
  afterDraw: (chart) => {
    const ctx = chart.ctx
    ctx.save()
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.font = '16px Arial'
    ctx.fillStyle = '#000'
    const centerX = (chart.chartArea.left + chart.chartArea.right) / 2
    const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2
    //ctx.fillText('Total: ' + chart.data.datasets[0].data.reduce((a, b) => a + b, 0), centerX, centerY)
    ctx.restore()
  },
}

const MyDonutChart = ({ data, options, onClick }) => {
  const chartRef = useRef(null)

  useEffect(() => {
    const chart = chartRef.current
    if (chart) {
      chart.canvas.onclick = (event) => {
        const elements = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true)
        if (elements.length) {
          const firstElement = elements[0]
          const label = chart.data.labels[firstElement.index]
          onClick(label)
        }
      }
    }
  }, [chartRef, onClick])

  return <Doughnut ref={chartRef} data={data} options={options} plugins={[centerTextPlugin]} />
}

export default MyDonutChart
